import React from "react";
import { Box, Button, Dialog } from "@mui/material";
import alertIcon from "@iconify/icons-mdi/alert-circle-outline";
import { InlineIcon } from "@iconify/react";

interface OcInfoDialogProps {
  open: boolean;
  onClose: () => void;
  text: string;
  handleDialogClose: () => void;
  filterItemErrors?: string[];
  isMobile: boolean;
}

export const OcInfoDialog: React.FC<OcInfoDialogProps> = ({
  open,
  onClose,
  text,
  handleDialogClose,
  filterItemErrors,
  isMobile,
}) => {
  return (
    <Dialog onClose={onClose} aria-labelledby="simple-dialog-title" open={open}>
      <Box width={isMobile ? "auto" : "476px"} padding="16px">
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          paddingBottom="16px"
        >
          <Box paddingRight="20px">
            <InlineIcon icon={alertIcon} width="30px" color="#cc0033" />
          </Box>
          <Box fontSize="16px" letterSpacing="0.44px" color="#5E6366">
            {text}
          </Box>
        </Box>
        {(filterItemErrors?.length ?? 0) > 0 && (
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            paddingBottom="16px"
          >
            <Box fontSize="16px" letterSpacing="0.44px" color="#5E6366">
              ({filterItemErrors?.toString()})
            </Box>
          </Box>
        )}
        <Button
          id="ok-button"
          variant="contained"
          color="primary"
          disableElevation
          fullWidth
          onClick={handleDialogClose}
        >
          OK
        </Button>
      </Box>
    </Dialog>
  );
};

export default OcInfoDialog;
